import { initStage } from '@aytm/lib/shelves/stage'
import { getFromArray, putToArray } from '@aytm/lib/common/array'
import drawProduct, {
  getProductImage,
  FIRST_LAYER_COLOR,
  SECOND_LAYER_COLOR,
  THIRD_LAYER_COLOR,
  HIDDEN_COLOR
} from '@aytm/lib/shelves/product'
import { fromJS, Map } from 'immutable'
// import domtoimage from 'dom-to-image-more'

// pallet section stride in coordinate units; matches the backend per-section canvas width (sh_front canvas_width)
export const PALLET_SECTION_WIDTH = 590

export default function ShelvesContainer(div, width, height, onProductClick, generateImage, topShelf) {
  const CANVAS_RESIZE_FACTOR = width > 2000 || generateImage ? 1 : 2
  ;[this.pixiApp, this.container, this.ticker, this.loader, this.renderer] = initStage(
    div,
    CANVAS_RESIZE_FACTOR * width,
    CANVAS_RESIZE_FACTOR * height
  )
  this.leftArray = []
  this.goodState = []
  this.productCoordinates = []
  this.upperCoordinates = []
  this.childs = []

  // document.addEventListener('visibilitychange', () => {
  //   this.generateImg()
  // })

  this.destroy = () => {
    // CHECK all
    // this.renderer.context.gl.getExtension('WEBGL_lose_context').loseContext()
    // this.renderer.framebuffer.gl.getExtension('WEBGL_lose_context').loseContext()
    // this.renderer.geometry.gl.getExtension('WEBGL_lose_context').loseContext()
    // this.renderer.state.gl.getExtension('WEBGL_lose_context').loseContext()
    // this.renderer.texture.gl.getExtension('WEBGL_lose_context').loseContext()

    this.renderer.destroy()
    this.container.destroy()
    this.pixiApp.destroy()
    this.loader.reset()
  }

  this.removeChildren = () => {
    this.container.removeChildren()
  }

  this.addChild = cat => {
    this.container.addChild(cat)
  }

  this.getUpperCoordinates = index => this.upperCoordinates[index]

  this.getImage = () => {
    const data = this.renderer.plugins.extract.image(this.container)
    // const img = new Image()
    // img.src = data
    // document.body.appendChild(data)
    window.newImg = data
  }

  this.getUpperImage = answer => {
    const image =
      answer.get('gallery') != undefined
        ? answer.get('gallery').find(image => 'single' == image.getIn(['product', 'image_type'])) || Map({})
        : answer.get('height') < this.config.topShelf.height * this.config.widthFactor
          ? answer.get('image')
          : Map({})
    return image
  }

  this.drawScene = (
    config,
    answers,
    answersMask,
    coordinates,
    counts,
    shelvesSchema,
    takenGoods,
    answersImages,
    onHover
    // eslint-disable-next-line max-params
  ) => {
    this.config = config
    this.answersMask = answersMask
    this.shelvesSchema = shelvesSchema
    this.takenGoods = takenGoods
    this.productCoordinates = []
    this.shelfHeights = []
    this.coordinates = coordinates.toJS()
    this.counts = counts.toJS()
    this.onHover = onHover
    this.image = null
    this.generated = false

    this.generateImg = () => {
      if (!config.last || this.generated) return
      const self = this
      self.generated = true
      setTimeout(() => {
        if ('function' == typeof generateImage) generateImage()
      }, 200)
    }

    this.getLeft = (x, indexes) => {
      if (!indexes[3] || this.config.scrolling || this.config.noPerspective) return 0
      // if ('counterFridge' == this.config.styleClass) return 0
      // perspective uses absolute x to converge on the global center; section placement is via additionalX, not here
      const productX =
        (x - (this.config.doubleWidth && !this.config.first ? (this.config.fridge ? 400 : 0) : 0)) /
          this.config.widthFactor +
        config.blockWidths[0]

      return getFromArray(this.leftArray, indexes) != null
        ? Math.round(getFromArray(this.leftArray, indexes))
        : putToArray(
            this.leftArray,
            indexes,
            'counterFridge' == this.config.styleClass
              ? 6 * (Math.random() - 0.5)
              : -(productX - config.blockWidths[1] / 2) * 0.15 * indexes[3] * (1 == indexes[3] ? 1 : 0.85)
          )
    }

    // let productIndex
    shelvesSchema.forEach((shelf, index) => {
      const lastShelf = index == shelvesSchema.size - 1
      this.shelfHeights.push(
        (this.config.customConfig && 'pegboard' == this.config.customConfig.getIn([index, 'shelf_type'])
          ? this.config.pegAir
          : this.config.air) +
          (this.config.customConfig
            ? (index ? this.shelfHeights[index - 1] : 0) + this.config.customConfig.getIn([index, 'height'])
            : this.config.height)
      )
      this.itemsBefore = 0

      // productIndex = 0
      Array.apply(null, Array(shelf.size)).forEach((_, packIndex) => {
        const answer = answers.get(shelf.getIn([packIndex, 0]))
        if (answer.get('reallyHidden')) return
        const image = getProductImage(answer)
        const itemsCount = shelf.getIn([packIndex, 1])
        const halfIndex =
          config.palletSectionsCount > 1
            ? config.palletSectionIndex * 2 + index
            : config.doubleWidth
              ? config.first
                ? index
                : 2 + index
              : index
        this.itemsBefore += packIndex
          ? this.counts[index][packIndex - 1] * shelvesSchema.getIn([index, packIndex - 1, 1])
          : 0
        Array.apply(
          null,
          Array(generateImage ? 1 : lastShelf && config.lastDeep ? config.lastDeep : config.deep)
        ).forEach((_, _layerIndex) => {
          const layerIndex = generateImage && lastShelf && config.lastDeep ? config.lastDeep - 1 : _layerIndex
          const deep = lastShelf && config.lastDeep ? config.lastDeep : config.deep
          if (config.double && topShelf && 0 == layerIndex) {
            const upperImage = this.getUpperImage(answer)
            if (upperImage && upperImage.size) {
              const upperCat = drawProduct(
                this.packUpperConfig(
                  answersImages[answer.get('id') + '_top']
                    ? answersImages[answer.get('id') + '_top']
                    : getProductImage(
                        fromJS({
                          width: Math.round(upperImage.getIn(['product', 'width']) * this.config.widthFactor),
                          height: Math.round(upperImage.getIn(['product', 'height']) * this.config.widthFactor),
                          picture: upperImage
                        })
                      ),
                  upperImage,
                  answer,
                  [index, packIndex],
                  itemsCount
                ),
                CANVAS_RESIZE_FACTOR
              )
              this.container.addChild(upperCat)
            }
          }

          Array.apply(null, Array(this.counts[index][packIndex])).forEach((_, verticalIndex) => {
            Array.apply(null, Array(itemsCount)).forEach((_, itemIndex) => {
              if (
                !takenGoods.getIn([
                  halfIndex + config.firstShelf,
                  packIndex,
                  itemIndex,
                  verticalIndex * deep + deep - layerIndex - 1
                ]) ||
                answer.get('fakeHidden') ||
                !answer.getIn(['image', 'original_path'])
              ) {
                const config = this.packConfig(
                  answersImages[answer.get('id')] ? answersImages[answer.get('id')] : image,
                  answer,
                  [index, packIndex, itemIndex, layerIndex, verticalIndex]
                )
                if (!config) return
                if (config.maxStacking && this.counts[index][packIndex] - verticalIndex > config.maxStacking) return
                const cat = drawProduct(config, CANVAS_RESIZE_FACTOR)
                // const halfCoordIndex = this.config.doubleWidth
                //   ? this.config.first
                //     ? this.config.fridge
                //       ? index * 2
                //       : index
                //     : this.config.fridge
                //     ? 1 + index * 2
                //     : index + 2
                //   : index
                // if (0 == layerIndex) {
                //   config.x =
                //     (coordinates.getIn([halfCoordIndex, productIndex, 0]) -
                //       (this.config.doubleWidth && !this.config.first ? (this.config.fridge ? 380 : 600) : 0)) *
                //     CANVAS_RESIZE_FACTOR
                //   config.y = coordinates.getIn([halfCoordIndex, productIndex, 1]) * CANVAS_RESIZE_FACTOR
                //   config.z = 100
                //   config.width = coordinates.getIn([halfCoordIndex, productIndex, 2]) * CANVAS_RESIZE_FACTOR
                //   config.height = coordinates.getIn([halfCoordIndex, productIndex, 3]) * CANVAS_RESIZE_FACTOR
                //   config.tint = 0xff0000
                //   const newCat = drawProduct(config, this.ticker)
                //   this.container.addChild(newCat)
                //   productIndex++
                // }

                putToArray(
                  this.goodState,
                  [halfIndex, packIndex, itemIndex, verticalIndex * deep + deep - layerIndex - 1],
                  cat
                )
                if (generateImage && 0 == layerIndex)
                  this.productCoordinates.push({
                    id: answer.get('id'),
                    x: config.x - config.width / 2,
                    y: config.y - config.height / 2
                  })
                this.container.addChild(cat)
                this.childs.push(cat)
              }
            })
          })
        })
      })
    })
    if (generateImage) {
      window.AYTM_SHELF_PRODUCTS = this.productCoordinates
      if (window['AYTM_shelfImage_' + this.config.id] && window['AYTM_shelfImage_' + this.config.id].src) return

      this.generateImg()
    }

    if (this.config.getContainer) {
      this.scrollContainer = this.config.getContainer()

      if (this.config.scrolling && !generateImage && !this.config.noPerspective) {
        const self = this
        this.ticker.add(__delta => {
          if (this.scrollContainer) {
            const childElement = self.scrollContainer.children[0].children[0]
            const scale = childElement.getBoundingClientRect().width / childElement.offsetWidth
            const scrollLeft = this.scrollContainer.scrollLeft
            const viewPortStart = (CANVAS_RESIZE_FACTOR * scrollLeft) / scale
            const viewPortEnd = (CANVAS_RESIZE_FACTOR * (scrollLeft + window.innerWidth)) / scale
            const viewPortWidth = (CANVAS_RESIZE_FACTOR * window.innerWidth) / 2 / scale

            // console.log(viewPortStart)
            // console.log(viewPortEnd)
            // console.log(viewPortWidth)

            // console.log(self.scrollContainer)
            this.childs.forEach(child => {
              const childX = child.x + config.blockWidths[0] * this.config.widthFactor * CANVAS_RESIZE_FACTOR
              if (child.orderZ && childX > viewPortStart && childX < viewPortEnd + child.width) {
                const delta = childX - viewPortStart
                child.x = child.oldX - 0.01 * (delta - viewPortWidth) * child.orderZ
                if (child.x < 0) child.x = 0
                if (child.x > CANVAS_RESIZE_FACTOR * width - child.width) {
                  child.x = CANVAS_RESIZE_FACTOR * width - child.width
                }
              }
            })
          }
        })
      }
    }
  }

  this.checkAvailability = indexes => {
    ;(indexes[3] + 1) % this.config.deep && getFromArray(this.goodState.current, indexes)
  }

  this.getCenter = (imageWidth, answer, indexes, itemsCount) => {
    const topIndex = Math.trunc(itemsCount / 2)
    const doubleIndex = this.config.double ? Math.trunc(indexes[0] / 2) : indexes[0]
    return Math.min(
      Math.round(
        this.answersMask[indexes[0]][indexes[1]][topIndex] -
          answer.get('width') / (itemsCount / 2 == topIndex ? 1 : 2) -
          (imageWidth * this.config.widthFactor) / 2 +
          Number(width / (this.config.double ? 2 : 1) - this.answersMask[indexes[0]][-1]) / 2 +
          (doubleIndex != indexes[0] ? width / 2 : 0)
      ),
      width - imageWidth * this.config.widthFactor
    )
  }

  this.packCallback = (answer, indexes) => coords => {
    const halfIndex =
      this.config.palletSectionsCount > 1
        ? this.config.palletSectionIndex * 2 + indexes[0]
        : this.config.doubleWidth
          ? this.config.first
            ? indexes[0]
            : 2 + indexes[0]
          : indexes[0]
    const doubleIndex = this.config.double ? Math.trunc(indexes[0] / 2) : indexes[0]
    const lastShelf = indexes[0] == this.shelvesSchema.size - 1
    const deep = lastShelf && this.config.lastDeep ? this.config.lastDeep : this.config.deep

    let removeIndex = indexes[4] * deep + deep - indexes[3] - 1
    if (
      this.config.double ||
      (this.config.customConfig &&
        'auto' == this.config.customConfig.getIn([doubleIndex, 'stacking']) &&
        this.config.styleClass != 'counterFridge')
    ) {
      while (
        removeIndex > 0 &&
        removeIndex - deep >= 0 &&
        getFromArray(this.goodState, [halfIndex, indexes[1], indexes[2], removeIndex - deep])
      )
        removeIndex = removeIndex - deep
    }

    onProductClick(
      answer,
      [halfIndex + this.config.firstShelf, indexes[1], indexes[2], removeIndex],
      () => {
        if (!this.config.scrolling) this.ticker.start()
        this.container.removeChild(this.goodState[halfIndex][indexes[1]][indexes[2]][removeIndex])
        this.goodState[halfIndex][indexes[1]][indexes[2]][removeIndex] = null
        if (!this.config.scrolling) setTimeout(() => this.ticker.stop(), 1000)
      },
      coords
    )
  }

  this.packUpperCallback = (answer, indexes, newImage) => coords => {
    const halfIndex =
      this.config.palletSectionsCount > 1
        ? this.config.palletSectionIndex * 2 + indexes[0]
        : this.config.doubleWidth
          ? this.config.first
            ? indexes[0]
            : 2 + indexes[0]
          : indexes[0]

    onProductClick(
      answer.set('currentPicture', newImage),
      [halfIndex, indexes[1], 0, 0],
      () => {
        if (!this.config.scrolling) this.ticker.start()
        this.container.removeChild(this.goodState[halfIndex][indexes[1]][0][0])
        this.goodState[halfIndex][indexes[1]][0][0] = null
        if (!this.config.scrolling) setTimeout(() => this.ticker.stop(), 1000)
      },
      coords
    )
  }

  this.packUpperConfig = (image, newImage, answer, indexes, itemsCount) => {
    const productConfig = {}
    const doubleIndex = this.config.double ? Math.trunc(indexes[0] / 2) : indexes[0]
    productConfig.width = CANVAS_RESIZE_FACTOR * newImage.getIn(['product', 'width']) * this.config.widthFactor
    productConfig.height =
      CANVAS_RESIZE_FACTOR *
      Math.round(newImage.getIn(['product', 'height']) + newImage.getIn(['product', 'offset_y'])) *
      this.config.widthFactor
    productConfig.maxHeight =
      this.config.widthFactor *
      CANVAS_RESIZE_FACTOR *
      (this.config.customConfig ? this.config.customConfig.getIn([indexes[0], 'height']) : this.config.height)
    productConfig.canvasHeight =
      image.height + (image.width / answer.get('width')) * newImage.getIn(['product', 'offset_y'])
    productConfig.canvasWidth = image.width
    productConfig.emulatedMobile = this.config.emulatedMobile
    productConfig.x =
      CANVAS_RESIZE_FACTOR * this.getCenter(newImage.getIn(['product', 'width']), answer, indexes, itemsCount)
    productConfig.interactive = Boolean(!answer.get('fakeHidden') && answer.getIn(['image', 'original_path']))
    productConfig.additionalX =
      this.config.palletSectionsCount > 1
        ? this.config.palletSectionIndex * PALLET_SECTION_WIDTH
        : this.config.doubleWidth && !this.config.first
          ? 600
          : 0
    putToArray(
      this.upperCoordinates,
      [doubleIndex, (this.upperCoordinates[doubleIndex] || []).length],
      Math.min(productConfig.x / CANVAS_RESIZE_FACTOR - 10, 500) //TODO
    )
    productConfig.available = answer.get('available') != false
    productConfig.y =
      CANVAS_RESIZE_FACTOR *
      (((this.config.height + this.config.air) * this.config.widthFactor) / 2 +
        this.config.topBottom -
        (newImage.getIn(['product', 'height']) + newImage.getIn(['product', 'offset_y'])) * this.config.widthFactor)
    productConfig.hoverY = productConfig.y / CANVAS_RESIZE_FACTOR
    productConfig.z = 2
    productConfig.last = (this.config.double ? Math.trunc(indexes[0] / 2) : indexes[0]) < this.shelvesSchema.size - 1
    productConfig.callback = this.packUpperCallback(answer, indexes, newImage)
    productConfig.perspective = 1
    productConfig.image = image
    productConfig.tint = FIRST_LAYER_COLOR
    productConfig.onHover = generateImage ? null : productConfig.available ? this.onHover : () => {}
    productConfig.additionalX = productConfig.additionalX + this.config.blockWidths[0] * this.config.widthFactor
    productConfig.noHover = answer.get('fakeHidden') || !productConfig.available

    return productConfig
  }

  this.packConfig = (image, answer, indexes) => {
    const calculateDeltas = () => {
      if (!this.config.double) return 0
      if (this.config.styleClass != 'counterFridge') return 0
      if (indexes[0] + 2 >= this.shelvesSchema.size) return 0
      return indexes[0] % 2
        ? -(
            0.25 *
            (this.answersMask[indexes[0]].length - indexes[1]) *
            (width / 2 - this.answersMask[indexes[0] - 1][-1])
          ) / this.answersMask[indexes[0]].length
        : (0.25 *
            (indexes[1] + 1) *
            (this.answersMask[indexes[0] + 1] && this.answersMask[indexes[0] + 1][0]
              ? this.answersMask[indexes[0] + 1][0][0]
              : 0)) /
            this.answersMask[indexes[0]].length
    }

    const productConfig = {}
    productConfig.scrolling = this.config.scrolling
    productConfig.doubleIndex = this.config.double ? Math.trunc(indexes[0] / 2) : indexes[0]
    productConfig.stacking =
      this.config.double ||
      (this.config.customConfig && 'auto' == this.config.customConfig.getIn([productConfig.doubleIndex, 'stacking']))
    productConfig.maxStacking = answer.get('max_stacking')
    productConfig.available = answer.get('available') != false

    productConfig.maxHeight =
      this.config.widthFactor *
        CANVAS_RESIZE_FACTOR *
        (this.config.customConfig ? this.config.customConfig.getIn([indexes[0], 'height']) : this.config.height) -
      2
    const productCoordinates =
      this.coordinates[indexes[0]][
        this.counts[indexes[0]][indexes[1]] * indexes[2] +
          this.itemsBefore +
          (this.counts[indexes[0]][indexes[1]] - indexes[4] - 1)
      ]

    productConfig.verticalCount = this.counts[indexes[0]][indexes[1]]

    // console.log(this.coordinates)
    // console.log(productConfig.doubleIndex)
    // console.log(this.itemsBefore)
    // console.log(this.verticalCounts)
    // console.log(indexes[4])
    // console.log(this.verticalCounts[indexes[0]][indexes[1]] * indexes[2] + this.itemsBefore + indexes[4])
    //[index, packIndex, itemIndex, layerIndex, verticalIndex]

    if (!productCoordinates) {
      // eslint-disable-next-line no-console
      console.log('aloha!')
      return
    }

    const offsetY = answer.get('offset_y') < 0 ? answer.get('offset_y') : 0
    productConfig.image = image
    productConfig.deep = this.config.deep
    productConfig.lastShelf = indexes[0] == this.shelvesSchema.size - 1
    productConfig.canvasHeight = image.height + (image.width / answer.get('width')) * offsetY
    productConfig.canvasWidth = image.width
    productConfig.perspective =
      this.config.perspective != undefined && productConfig.lastShelf && indexes[3] > 2 && !this.config.noPerspective
        ? parseFloat(this.config.perspective)
        : 1
    productConfig.width = CANVAS_RESIZE_FACTOR * Math.round(answer.get('width')) * productConfig.perspective - 2
    productConfig.height = CANVAS_RESIZE_FACTOR * Math.round(answer.get('height') * productConfig.perspective + offsetY)
    productConfig.interactive = Boolean(!answer.get('fakeHidden') && answer.getIn(['image', 'original_path']))
    productConfig.z = indexes[3]
    productConfig.emulatedMobile = this.config.emulatedMobile
    productConfig.bottomHover =
      this.config.customConfig &&
      'pegboard' == this.config.customConfig.getIn([productConfig.doubleIndex, 'shelf_type'])

    productConfig.additionalX =
      this.config.palletSectionsCount > 1
        ? this.config.palletSectionIndex * PALLET_SECTION_WIDTH
        : this.config.doubleWidth && !this.config.first
          ? this.config.fridge
            ? 400
            : 600
          : 0

    productConfig.x =
      CANVAS_RESIZE_FACTOR *
      Math.round(
        productCoordinates[0] +
          (generateImage
            ? 0
            : 0.1 *
              Math.sqrt(productConfig.width) *
              this.getLeft(productCoordinates[0], [
                indexes[0],
                indexes[1],
                indexes[2],
                this.config.deep - indexes[3] - 1,
                indexes[4]
              ])) -
          // answer.get('width') * (1 + (productConfig.perspective - 1) / 2) +
          calculateDeltas() -
          productConfig.additionalX
      )

    productConfig.last = productConfig.doubleIndex >= this.shelvesSchema.size / 2 - 1
    productConfig.doubleIndex = this.config.double ? Math.trunc(indexes[0] / 2) : indexes[0]

    productConfig.additionalX =
      this.config.palletSectionsCount > 1
        ? this.config.palletSectionIndex * PALLET_SECTION_WIDTH
        : this.config.doubleWidth && !this.config.first
          ? this.config.fridge
            ? 430
            : 600
          : 0

    productConfig.additionalX = productConfig.additionalX + this.config.blockWidths[0] * this.config.widthFactor
    productConfig.hoverY = Math.round(
      productCoordinates[1] -
        ('counterFridge' == this.config.styleClass && !this.config.noPerspective
          ? 0.5 *
            this.getLeft(productCoordinates[0], [
              indexes[0],
              indexes[1],
              indexes[2],
              this.config.deep - indexes[3] - 1,
              indexes[4]
            ])
          : 0)
    )

    productConfig.noGravitation = 'counterFridge' == this.config.styleClass
    // if (productConfig.noGravitation)
    //   productConfig.hoverY = this.config.height * this.config.widthFactor - productConfig.hoverY

    productConfig.y =
      CANVAS_RESIZE_FACTOR *
      Math.round(
        productConfig.hoverY +
          (this.config.noPerspective
            ? 0
            : indexes[0] > 2 ||
                (this.config.customConfig &&
                  'pegboard' == this.config.customConfig.getIn([productConfig.doubleIndex, 'shelf_type']))
              ? (2 - indexes[0]) * (2 - indexes[3]) * productConfig.perspective
              : 0)
      )

    if (
      productConfig.maxHeight < productConfig.height &&
      'pegboard' != this.config.customConfig.getIn([indexes[0], 'shelf_type'])
    )
      productConfig.y = productConfig.y - productConfig.maxHeight + productConfig.height - 3

    productConfig.tint = FIRST_LAYER_COLOR
    productConfig.noHover =
      answer.get('fakeHidden') ||
      !answer.getIn(['image', 'original_path']) ||
      this.checkAvailability(indexes) ||
      !productConfig.available

    if (productConfig.z < this.config.deep - 1) {
      if (
        ('counterFridge' == this.config.styleClass &&
          this.takenGoods.getIn([
            indexes[0],
            indexes[1],
            indexes[2],
            indexes[4] * this.config.deep + this.config.deep - indexes[3] - 2
          ])) ||
        generateImage ||
        this.config.noPerspective
      )
        productConfig.tint = FIRST_LAYER_COLOR
      else {
        productConfig.tint = productConfig.z < this.config.deep - 2 ? SECOND_LAYER_COLOR : THIRD_LAYER_COLOR
        productConfig.order = productConfig.z < this.config.deep - 2 ? 4 : 2
      }
    }

    if (answer.get('fakeHidden')) {
      productConfig.tint = HIDDEN_COLOR
    }
    productConfig.callback = this.packCallback(answer, indexes)
    productConfig.onHover = generateImage ? null : productConfig.available ? this.onHover : () => {}

    return productConfig
  }
}
